import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CharterType } from 'anchor-shared/lib/model/enum/charter-type';

@Component({
  selector: 'app-buyflow-deposit-dialog',
  templateUrl: './buyflow-deposit-dialog.component.html',
  styleUrls: ['./buyflow-deposit-dialog.component.scss'],
})
export class BuyflowDepositDialogComponent implements OnInit {
  depositAmount: number;
  charterType: CharterType;
  CharterType = CharterType;

  constructor(
    private dialogRef: MatDialogRef<BuyflowDepositDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.depositAmount = data.depositAmount;
    this.charterType = data.charterType;
  }

  ngOnInit(): void {}
}
